import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTranslations from '../../../translation/use-translations';
import Balance from '../../../header/balance.js';
import { selectIsEventLive, initDashboard } from '../ducks/we-spin-dashboard-duck.js';
import { WE_SPIN_STREAMER_IN_GAME_HEADER_TEXT_KEYS } from '../constants/we-spin-text-keys.js';

const WeSpinBalance = ({ balances, isInGame, ...rest }) => {
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_STREAMER_IN_GAME_HEADER_TEXT_KEYS);
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(initDashboard());
	}, [dispatch]);

	const isEventLive = useSelector(selectIsEventLive);
	const prefix = isEventLive ? `${tr.WE_SPIN_STREAMER_IN_GAME_HEADER_BALANCE_LABEL}: ` : '';
	// balance has been modified to contain product specific balances. so add the prefix only for total balance
	const modifiedBalances = { ...balances, totalBalance: `${prefix}${balances.totalBalance}` };
	return (
		!isLoadingTranslations && (
			<Balance balances={modifiedBalances} isInGame={isInGame} isEventLive={isEventLive} {...rest} />
		)
	);
};

export default WeSpinBalance;
